import { stdObject } from "../../../data/types/stdObject";
import { writeTax } from "../../../utils/writeTax";

export const getParamName = ({
  key,
  code,
  data,
  label,
  statusDict,
}: stdObject) => {
  switch (key) {
    case "INT":
      return data[`INTN${code}`];
    case "PRE":
      return writeTax(data[`PIM${code}`], label);
    case "PAG":
      return statusDict[data[`${key}${code}`]]?.NOMPAG;
    case "RES":
      return data[`NRS${code}`];
    case "CLI":
      return data[`NOM${code}`];
    default:
      return "";
  }
};
